import { useSelector } from 'react-redux';

import { useClientAppConfigWebHandler_getFeature } from '@zg-rentals/ts-rental-manager-api-beta-client-react-query';

import { RoutingSelectors } from '../selectors';
import accessUtils from '../utils/accessUtils';

const useMultiplexListingFlow = () => {
  const search = useSelector((state) => RoutingSelectors.makeSearch(state));

  const { isLoading, data = 'false' } = useClientAppConfigWebHandler_getFeature({
    appName: 'zrm_web',
    featureName: 'canAccessMultiplexListingFlow',
  });

  const multiplexBuildingSessionId = new URLSearchParams(search).get('multiplexBuildingSessionId');

  const canAccessMultiplexListingFlow = accessUtils.canAccessMultiplexListingFlow({
    canAccessMultiplexListingFlowResponse: data,
  });

  const isInMultiplexListingFlow = isLoading
    ? null
    : canAccessMultiplexListingFlow && Boolean(multiplexBuildingSessionId);

  return {
    isLoading,
    isInMultiplexListingFlow,
  };
};

export default useMultiplexListingFlow;
